import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BookingApi } from 'src/lib/repository/booking/booking.api';
import { IBooking } from 'src/lib/repository/booking/booking.model';

export const bookingDetailResolver: ResolveFn<IBooking> = (route) => {
  const bookingApi = inject(BookingApi);

  return bookingApi.findItem(route.params['id']);
};
